<template>
  <div
    :class="getLoading && 'bg-white'"
    class="flex-auto px-4 lg:px-10 py-10 pt-0"
  >
    <div
      v-if="getLoading"
      class="bg-white w-full flex flex-col py-10 justify-center items-center"
    >
      <!-- https://gannon.tv/intro -->
      <img width="260" src="@/assets/imgs/loading.gif" alt="loading" />
      <h3>Loading...</h3>
    </div>
    <div v-if="!hasContent && !getLoading">
      <p class="justify-center items-center flex mt-10">
        This component has no attributes
      </p>
    </div>
    <form v-if="hasContent">
      <h6
        v-if="
          getBasicAttributes ? Object.keys(getBasicAttributes).length : null
        "
        class="text-blueGray-400 text-sm mt-3 ml-4 mb-6 font-bold uppercase"
      >
        Instance Info
      </h6>
      <div class="flex flex-wrap">
        <div v-if="!getLoading" class="w-full lg:w-4/12 px-4">
          <label
            class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
          >
            Instance Name
          </label>
          <input
            type="text"
            v-model="formDataLocal.instance_name"
            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
          />
        </div>
      </div>
      <hr v-if="!getLoading" class="mt-6 border-b-1 border-blueGray-300" />
      <h6
        v-if="
          getBasicAttributes ? Object.keys(getBasicAttributes).length : null
        "
        class="text-blueGray-400 text-sm mt-3 ml-4 mb-6 font-bold uppercase"
      >
        Basic
      </h6>
      <div class="flex flex-wrap">
        <div
          class="w-full lg:w-4/12 px-4"
          v-for="(value, name) in basicAttributes"
          :key="name"
        >
          <div v-if="value.type === 'number'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <input
              type="number"
              autocomplete="off"
              data-lpignore="true"
              v-model="formDataLocal['attributes'][name]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
          <div
            v-else-if="value.type === 'short_text'"
            class="relative w-full mb-3"
          >
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <input
              type="text"
              v-model="formDataLocal['attributes'][name]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
          <div
            v-else-if="value.type === 'select' || value.type === 'boolean'"
            class="relative w-full mb-3"
          >
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <select
              v-model="formDataLocal['attributes'][name]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            >
              <option
                v-for="(option, index) in changeOptionsFormat(value.options)"
                :key="index"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div v-else-if="value.type === 'url'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <URLInput
              :url="
                formData['attributes'][name] ? formData['attributes'][name] : ''
              "
              @update:url="(val) => handleUpdateValue(val, name)"
            />
          </div>
          <div v-else-if="value.type === 'icon'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <IconPicker
              :icons="value.options"
              :icon="
                formData['attributes'][name] ? formData['attributes'][name] : ''
              "
              @update:icon="(val) => handleUpdateValue(val, name)"
            />
          </div>
          <div v-else class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <input
              v-model="formDataLocal['attributes'][name]"
              type="text"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
      </div>
      <hr v-if="!getLoading" class="mt-6 border-b-1 border-blueGray-300" />
      <div v-if="summaryType === 'list'">
        <h6
          v-if="
            getBasicAttributes ? Object.keys(getBasicAttributes).length : null
          "
          class="text-blueGray-400 text-sm mt-3 ml-4 mb-6 font-bold uppercase"
        >
          Elements
        </h6>
        <div class="flex flex-wrap">
          <DNElement
            v-for="index in itemNumber || 1"
            :key="index"
            :index="String(index)"
            :elementName="elementName"
            :formData="formData['attributes']"
            :dynamicAttributes="dynamicAttributes"
            @update:formData="handleUpdateFormData"
          />
        </div>
      </div>
      <div v-else>
        <h6
          v-if="
            getBasicAttributes ? Object.keys(getBasicAttributes).length : null
          "
          class="text-blueGray-400 text-sm mt-3 ml-4 mb-6 font-bold uppercase"
        >
          Additional
        </h6>
        <div class="flex flex-wrap">
          <div
            class="w-full px-4"
            v-for="(value, name) in textAttributes"
            :key="name"
          >
            <div v-if="value.type === 'number'" class="relative w-full mb-3">
              <label
                class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              >
                <AttrTitleWithDescription
                  :title="formatAttrName(name)"
                  :description="value.description"
                />
              </label>
              <input
                type="number"
                autocomplete="off"
                data-lpignore="true"
                v-model="formDataLocal['attributes'][name]"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              />
            </div>
            <div
              v-else-if="value.type === 'short_text'"
              class="relative w-full mb-3"
            >
              <label
                class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              >
                <AttrTitleWithDescription
                  :title="formatAttrName(name)"
                  :description="value.description"
                />
              </label>
              <input
                type="text"
                v-model="formDataLocal['attributes'][name]"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              />
            </div>
            <div
              v-else-if="value.type === 'select' || value.type === 'boolean'"
              class="relative w-full mb-3"
            >
              <label
                class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              >
                <AttrTitleWithDescription
                  :title="formatAttrName(name)"
                  :description="value.description"
                />
              </label>
              <select
                v-model="formDataLocal['attributes'][name]"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              >
                <option
                  v-for="(option, index) in changeOptionsFormat(value.options)"
                  :key="index"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div v-else-if="value.type === 'url'" class="relative w-full mb-3">
              <label
                class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              >
                <AttrTitleWithDescription
                  :title="formatAttrName(name)"
                  :description="value.description"
                />
              </label>
              <URLInput
                :url="
                  formData['attributes'][name]
                    ? formData['attributes'][name]
                    : ''
                "
                @update:url="(val) => handleUpdateValue(val, name)"
              />
            </div>
            <div
              v-else-if="value.type === 'long_text'"
              class="relative w-full mb-3"
            >
              <label
                class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              >
                <AttrTitleWithDescription
                  :title="formatAttrName(name)"
                  :description="value.description"
                />
              </label>
              <ckeditor
                v-if="componentId === getComponentId('abi_coloured_block')"
                class="h-40 border-0 px-3 py-3 placeholder-blueGray-300 bg-white rounded shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                :editor="editor"
                :config="editorConfig"
                v-model="formDataLocal['attributes'][name]"
              />
              <textarea
                v-else
                type="text"
                v-model="formDataLocal['attributes'][name]"
                class="h-40 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              />
            </div>
            <div v-else-if="value.type === 'icon'" class="relative w-full mb-3">
              <label
                class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              >
                <AttrTitleWithDescription
                  :title="formatAttrName(name)"
                  :description="value.description"
                />
              </label>
              <IconPicker
                :icons="value.options"
                :icon="
                  formData['attributes'][name]
                    ? formData['attributes'][name]
                    : ''
                "
                @update:icon="(val) => handleUpdateValue(val, name)"
              />
            </div>
            <div v-else class="relative w-full mb-3">
              <label
                class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              >
                <AttrTitleWithDescription
                  :title="formatAttrName(name)"
                  :description="value.description"
                />
              </label>
              <input
                v-model="formDataLocal['attributes'][name]"
                type="text"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import * as Constants from "@/store/constants";
import * as Actions from "@/store/actions.type";
import DNElement from "@/components/ComponentModule/DynamicNumComponent/DNElement";
import AttrTitleWithDescription from "@/components/Shared/Headers/AttrTitleWithDescription";
import URLInput from "@/components/Shared/Input/URLInput";
import IconPicker from "@/components/Shared/Input/IconPicker";

export default {
  name: "SDNComponentCreateForm",
  components: {
    DNElement,
    ckeditor: CKEditor.component,
    URLInput,
    IconPicker,
    AttrTitleWithDescription
  },
  data() {
    return {
      lastItemNum: 0,
      editor: ClassicEditor,
      editorConfig: Constants.CK_EDITOR_CONFIG
    };
  },
  props: {
    elementName: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    attributesCategory: {
      type: Object,
      required: true
    },
    componentId: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.$store.dispatch(Actions.CLEAR_COMPONENT_ATTRIBUTES);
  },
  watch: {
    getBasicAttributes() {
      if (this.getBasicAttributes) {
        Object.keys(this.getBasicAttributes).forEach((item) => {
          if (!this.formDataLocal["attributes"][item]) {
            this.formDataLocal["attributes"][item] =
              this.getBasicAttributes[item].value;
          }
        });
      }
    },
    getAdditionalAttributes() {
      if (this.getAdditionalAttributes) {
        Object.keys(this.getAdditionalAttributes).forEach((item) => {
          if (!this.formDataLocal["attributes"][item]) {
            this.formDataLocal["attributes"][item] =
              this.getAdditionalAttributes[item].value;
          }
        });
      }
    },
    getAllAttributes() {
      this.itemNumber = 1;
    },
    dynamicAttributes() {
      if (Object.keys(this.dynamicAttributes).length) {
        // set default value for formdata
        Object.keys(this.dynamicAttributes).forEach((item) => {
          if (!this.formDataLocal.attributes[`${item}1`]) {
            this.formDataLocal.attributes[`${item}1`] = "";
          }
        });
      }
    },
    basicAttributes() {
      if (Object.keys(this.basicAttributes).length) {
        // set default value for formdata
        Object.keys(this.basicAttributes).forEach((item) => {
          if (!this.formDataLocal.attributes[`${item}`]) {
            this.formDataLocal.attributes[`${item}`] = "";
          }
        });
      }
    },
    itemNumber(newValue, oldValue) {
      if (this.itemNumber > 0) {
        // record the previous value
        if (oldValue) {
          this.lastItemNum = oldValue;
        }
        for (let i = 0; i < this.itemNumber; i++) {
          Object.keys(this.dynamicAttributes).forEach((item) => {
            if (!this.formDataLocal.attributes[`${item}${i + 1}`]) {
              this.formDataLocal.attributes[`${item}${i + 1}`] = "";
            }
          });
        }
        if (this.itemNumber < this.lastItemNum) {
          Object.keys(this.dynamicAttributes).forEach((item) => {
            for (let i = this.itemNumber + 1; i <= this.lastItemNum; i++) {
              delete this.formDataLocal.attributes[`${item}${i}`];
            }
          });
        }
      }
      // set the max item number to 10
      if (this.itemNumber > 10) {
        this.itemNumber = 10;
      }

      // set the min item number to 1
      if (this.itemNumber <= 0) {
        this.itemNumber = 1;
      }
    }
  },
  computed: {
    summaryType() {
      // set summary type
      let summaryTypeAttributeName = Object.keys(
        this.formData["attributes"]
      ).find((item) => item.includes("summary_type"));
      return this.formData["attributes"][summaryTypeAttributeName];
    },
    itemNumber: {
      get: function () {
        const itemNumAttrName = this.attributesCategory.basic_attributes.find(
          (item) => item.includes("cols")
        );
        return parseInt(this.formDataLocal.attributes[itemNumAttrName]);
      },
      set: function (val) {
        const itemNumAttrName = this.attributesCategory.basic_attributes.find(
          (item) => item.includes("cols")
        );
        this.formDataLocal.attributes[itemNumAttrName] = parseInt(val);
      }
    },
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    },
    basicAttributes() {
      let result = {};
      if (this.getAllAttributes) {
        const attrNames = Object.keys(this.getAllAttributes).filter((item) => {
          return this.attributesCategory.basic_attributes.includes(item);
        });
        attrNames.forEach((item) => {
          result[item] = this.getAllAttributes[item];
        });
        return result;
      } else {
        return {};
      }
    },
    dynamicAttributes() {
      let dynamicAttributes = {};
      if (this.getAllAttributes) {
        this.attributesCategory.list_attributes.forEach((item) => {
          Object.keys(this.getAllAttributes).forEach((i) => {
            if (i.includes(item)) {
              dynamicAttributes[item] = this.getAllAttributes[i];
            }
          });
        });
        return dynamicAttributes;
      } else {
        return {};
      }
    },
    textAttributes() {
      let textAttributes = {};
      if (this.getAllAttributes) {
        this.attributesCategory.text_attributes.forEach((item) => {
          Object.keys(this.getAllAttributes).forEach((i) => {
            if (i.includes(item)) {
              textAttributes[item] = this.getAllAttributes[i];
            }
          });
        });
        return textAttributes;
      } else {
        return {};
      }
    },
    hasContent() {
      if (
        (this.getBasicAttributes &&
          this.getAdditionalAttributes &&
          Object.keys(this.getBasicAttributes).length +
            Object.keys(this.getAdditionalAttributes).length ===
            0) ||
        !this.getBasicAttributes ||
        !this.getAdditionalAttributes
      ) {
        return false;
      } else {
        return true;
      }
    },
    ...mapGetters([
      "getLoading",
      "getBasicAttributes",
      "getAdditionalAttributes",
      "getAllAttributes",
      "getAllComponent"
    ])
  },
  methods: {
    formatAttrName(name) {
      const nameArray = name.split("_");
      nameArray.splice(0, 2);
      return nameArray.join(" ");
    },
    changeOptionsFormat(options) {
      const newOptions = options.map((item) => {
        return { label: item, value: item };
      });
      return newOptions;
    },
    handleUpdateFormData(val) {
      this.formDataLocal["attribute"] = val;
    },
    handleUpdateValue(val, name) {
      this.formDataLocal[name] = val;
    },
    getComponentId(componentName) {
      if (this.getAllComponent.find((item) => item.name === componentName)) {
        return this.getAllComponent.find((item) => item.name === componentName)
          .id;
      } else {
        return null;
      }
    }
  }
};
</script>
